import { CheckIcon } from '@repo/icons';
import React from 'react';

export default function SourceLabelOption({ children, selected }) {
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        gap: 4,
      }}
    >
      {children}
      {selected && <CheckIcon width="11" height="14" customColor="#2686be" />}
    </span>
  );
}
